@if ({ isImageLoaded: false, appearance: !isMobile || (displayMode$ | async) === 'list' || product.isHero ? borderRadius
: svgOnly }; as templateVar) {
<div
    class="alternatives-views-item"
    [class.no-pointer-events]="!isMobile || noPointerEvents"
    (touchstart)="startTouchAction()"
    (touchend)="endTouchAction()"
    (touchmove)="moveTouchAction()"
    (mouseleave)="mouseleaveAlternativesViewsItemEvent()"
    (mouseenter)="mouseenterAlternativesViewsItemEvent()">
    <h-carousel
        [initialSlide]="isMobile && !shouldDisplayVideo ? 0 : 1"
        [isKeyboardNavigationActive]="(layoutFacade.keyboardNavigation$ | async) === true"
        [isLoopEnabled]="!isMobile"
        [isMobile]="isMobile"
        [carouselTitle]="product.slug"
        (mouseover)="handleHover()"
        (mouseleave)="mouseOver = false"
        (click)="mouseOver = false"
        [isControlsDisplayed]="templateVar.isImageLoaded && (isFocused || mouseOver)"
        (slideChanged)="updateCarouselIndex($event)"
        [slideTo]="slideTo()">
        <span i18n="@@hermes.accessibility.product-alternate-views-title"> Alternate views </span>
        @for (asset of product.assets; track asset; let idx = $index) {

        <div class="asset-wrapper fade-in" *hSlide>
            @if (asset.type === assetMediaType.Image) {

            <img
                [alt]="asset.title"
                [attr.data-src]="getImageSrc(asset.url, product.isHero ? 'hero' : 'grid')"
                (load)="templateVar.isImageLoaded = true"
                class="swiper-lazy"
                [attr.fetchpriority]="isFetchpriorityImage ? 'high' : 'auto'" />

            @if (idx === 0) {

            <!-- Show VTO tag only if isVtoTagDisplayed is on true and only on the first image of the carousel on mobile -->
            @if (shouldDisplayVtoTag) {
            <h-tag
                [appearance]="templateVar.appearance"
                [tagSize]="isMobile ? 'xsmall' : 'small'"
                [backgroundOpacity]="0.6"
                class="tag">
                <h-svg-icon svg [name]="'camera-flash'"></h-svg-icon>
                @if (templateVar.appearance !== svgOnly) {
                <span
                    data-nosnippet
                    class="tag-label label-small-bold-uppercase"
                    i18n="@@hermes.product-page.vto-trybutton">
                    Try-it
                </span>
                }
            </h-tag>
            } @if (shouldDisplayEngravingTag) {
            <h-tag
                [appearance]="templateVar.appearance"
                [tagSize]="isMobile ? 'xsmall' : 'small'"
                [backgroundOpacity]="0.6"
                class="tag">
                <h-svg-icon svg [name]="'edit-text'"></h-svg-icon>
                @if (templateVar.appearance !== svgOnly) {
                <span data-nosnippet class="tab-label" i18n="@@hermes.product-grid.engraving-icon"> Engraving </span>
                }
            </h-tag>
            } } } @else {

            <h-video
                [posterUrl]="asset.posterUrl"
                [videoName]="asset.title"
                [alwaysShowControls]="true"
                [isLightMode]="true"
                [isPlaying]="(carrousselCurrentIndex === 1 || isMobile) && isPlayVideo"
                [mediaType]="'snackable_video'"
                [videoUrl]="asset.url"
                [controlPosition]="shouldDisplayTagDisplayOnly"
                [controlSize]="isMobile === true ? smallSize : mediumSize"
                [videoRatio]="'1-1'"
                (clickOnPlayPauseVideoControls)="onPlayPauseVideo($event)">
                <img
                    alt=""
                    [attr.data-src]="getImageSrc(asset.posterUrl)"
                    class="swiper-lazy"
                    [attr.fetchpriority]="isFetchpriorityImage ? 'high' : 'auto'" />
            </h-video>

            }
        </div>

        }
    </h-carousel>
</div>
}
